import { styled, Box as MuiBox, Typography } from '@mui/material';
import { useCommonTranslation } from '../../../hooks/useCommonTranslation';

interface PageHeaderProps {
  title: string;
}

const PREFIX = 'PageHeader';

const classes = {
  header: `${PREFIX}-header`,
  empty: `${PREFIX}-empty`,
};

const Box = styled(MuiBox)(({ theme }) => ({
  [`&.${classes.header}`]: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    background:
      'linear-gradient(0deg, rgba(1, 16, 18, 0.04) 0%, rgba(1, 16, 18, 0.04) 100%)',
    padding: theme.spacing(3),
    [`& h1`]: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(1),
    },
  },
  [`&.${classes.empty}`]: {
    height: theme.spacing(0),
  },
}));

function PageHeader({ title }: PageHeaderProps) {
  const t = useCommonTranslation();

  return (
    <>
      <Box className={classes.header + ' standout-section standout-top'}>
        <Typography variant="h1">{title}</Typography>
        <Box className={classes.empty}></Box>
      </Box>
    </>
  );
}

export default PageHeader;
